<template>
  <v-dialog 
    persistent 
    v-model="dialog"
    max-width="900px"
    style=""
    >
    <div style="background-color:#fff;overflow: hidden">
      <div class="py-2 d-flex justify-end pr-2">
        <v-icon size="30" @click="$emit('closeDialog', false)">mdi-alpha-x</v-icon>
      </div>
      <v-data-table 
        :headers="headers" 
        :items="etapasSucesso" 
        hide-default-footer
        mobile-breakpoint="0"
      >
        <template v-slot:[`item.etapa`]="{ item }">
        <div>
            {{item.etapa}}
        </div>
        </template>
        <template v-slot:[`item.download`]="{ item }">
          <div class="d-flex justify-end pr-12">
            <v-icon 
              @click="startProcessDownload(item)"
            >
              mdi-download
            </v-icon>
          </div>
        </template>
      </v-data-table>
    </div>
  </v-dialog>
</template>

<script>

export default {

  props: {
    id: {
      type: Number,
    },
    dialog: {
      type: Boolean,
      default: false,
    },
    etapas: {
      type:Array
    }
  },

  data: () => ({
    headers: [
      {
        text: "Etapa",
        value: "etapa",
      },
      {
        text: "Download",
        value: "download",
        align: "right",
      },
    ],
  }),

  computed: {
    
    etapasSucesso() {

      let etapasAmostra = [];

      for (const index in this.etapas) {

        if (this.etapas[index].status == 'SUCESSO') etapasAmostra.push(
          {
            etapa: this.etapas[index].nome,
            tipo: this.etapas[index].tipo,
          }
        );
      }

      return etapasAmostra;
    }
  },

  methods: {
    
    startProcessDownload(item) {

      this.$emit('download', {type: item.tipo, id: this.id});
      this.$emit('closeDialog', false);
    }
  },
};

</script>
